"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorHandler = exports.detectDomainRealm = exports.createAWSMonitoringDriver = exports.createDriverConfigBuilder = exports.createContextBuilder = exports.createAWSMetricsPublisher = exports.createMetricsPublisher = void 0;
var KatalMetrics = __importStar(require("@amzn/katal-metrics"));
var katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
var katal_monitoring_aws_driver_1 = require("@amzn/katal-monitoring-aws-driver");
// The sushi producer we'll use to record the metrics: https://code.amazon.com/packages/NexusMetricsRelayLambda/blobs/9c8754c9f55b53565f1a499b9089951f15cec9a9/--/src/com/amazon/nexus/metricsrelay/transformer/KatalMetricTransformer.java#L45-L48
var KATAL_MONS_SUSHI_PRODUCER = 'katal_sellercentral';
var SOURCE_GROUP_BASE_IDENTIFIER = 'com.amazon.eel.katal.metrics.core.nexus.sellercentral';
var SOURCE_GROUPS = {
    test: "".concat(SOURCE_GROUP_BASE_IDENTIFIER, ".gamma"),
    prod: SOURCE_GROUP_BASE_IDENTIFIER,
};
var ADDITIONAL_LOG_ERROR_INFO = {
    logLevel: 'ERROR',
    // This can be used to whitelist metrics with breakdown by attribution
    attribution: 'KatalMetrics',
    message: 'Metrics Failure',
};
// Mappings documented https://code.amazon.com/packages/MonsControlPlane/blobs/de5716484c86ef182cbdbf425410709c1265bf22/--/configuration/brazil/app/MonsControlPlane.cfg#L745-L752
var METRICS_DATASET_MAP = {
    1: 'NAAmazon-test',
    2: 'EUAmazon-test',
    3: 'FEAmazon-test',
    4: 'NAAmazon-prod',
    5: 'EUAmazon-prod',
    6: 'FEAmazon-prod',
};
// Meta tags defined by mons: https://code.amazon.com/packages/MonsControlPlane/blobs/a177198fae4e0af466f7f233fd690aa0bfc483ed/--/src/com/amazon/mons/control/html/SellerCentralLayoutHtmlResponseBuilder.java#L344
var REQUEST_ID_META = 'request_id';
var SITE_NAME_META = 'mons_site_name';
var APP_NAME_META = 'mons_app_name';
var DATASET_ID_META = 'katal_metrics_dataset_id';
/**
 * Makes a publisher.
 * Most applications will only ever call this method.
 *
 * @param serviceName override the mons service name in your metrics. Only needed if you're migrating from KatalMetricsSellerCentral
 * @returns Katal Metrics publisher configured for the given page and current mons site
 */
function createMetricsPublisher(serviceName) {
    var errorHandler = createErrorHandler();
    var driverConfigBuilder = createDriverConfigBuilder(errorHandler);
    var contextBuilder = createContextBuilder(serviceName);
    return new KatalMetrics.Publisher(driverConfigBuilder.build(), errorHandler, contextBuilder.build());
}
exports.createMetricsPublisher = createMetricsPublisher;
/**
 * Creates MetricsPublisher with AWS Based driver.
 * @param driverOptions Options for the AWS driver.
 * @param doPublishToSushi Flag to allow consumers to publish to Sushi along with AWS CloudWatch. Should only be used for migration need. Once migration is completed, please remove this parameter or pass value as false.
 * @param serviceName ServiceName to be used instead of auto calculated value from meta tag.
 * @returns KatalMetricsPublisher with AWS diver.
 */
function createAWSMetricsPublisher(driverOptions, doPublishToSushi, serviceName) {
    if (doPublishToSushi === void 0) { doPublishToSushi = false; }
    var errorHandler = createErrorHandler();
    var sushiDriver = doPublishToSushi
        ? createDriverConfigBuilder(errorHandler).build()
        : undefined;
    var contextBuilder = createContextBuilder(serviceName);
    var updatedDriverOptions = __assign(__assign({}, driverOptions), { metricsSushiDriver: sushiDriver });
    var awsDriver = createAWSMonitoringDriver(updatedDriverOptions);
    return new KatalMetrics.Publisher(awsDriver, errorHandler, contextBuilder.build());
}
exports.createAWSMetricsPublisher = createAWSMetricsPublisher;
function getMetaContent(name) {
    var element = document.querySelector("[name=\"a2z:".concat(name, "\"]"));
    if (!element || !element.getAttribute('content')) {
        throw new Error("KatalMetricsMons could not detect ".concat(name, ". Have you opted in to katalMetrics on Monster?"));
    }
    return element.getAttribute('content');
}
/**
 * Make a context builder for the given service name.
 * You only need to call this if you want to customize the default context.  Most applications will not need to do that.
 *
 * @return Metrics context builder configured for the current page and the given mons_app_name
 */
function createContextBuilder(serviceName) {
    var contextBuilder = new KatalMetrics.Context.Builder();
    var siteNameContent = getMetaContent(SITE_NAME_META);
    var siteName = capitalizeFirstLetter(siteNameContent);
    contextBuilder.withSite(siteName);
    var requestId = getMetaContent(REQUEST_ID_META);
    contextBuilder.withRelatedMetrics(new KatalMetrics.Metric.String('http_request_id', requestId));
    /* istanbul ignore next */
    if (contextBuilder.withRequestId) {
        contextBuilder.withRequestId(requestId);
    }
    serviceName = serviceName ? serviceName : getMetaContent(APP_NAME_META);
    contextBuilder.withServiceName(serviceName);
    return contextBuilder;
}
exports.createContextBuilder = createContextBuilder;
/**
 * Make a driver configuration builder.
 *
 * You only need to call this if you want to customize the default context.  Most applications will not need to do that.
 *
 * @param errorHandler Error handler function
 * @return Sushi driver builder configured for the current page
 */
function createDriverConfigBuilder(errorHandler) {
    // If we couldn't autodetect domain or realm, we already logged an error above
    // Now just use defaults, because some metrics are better than no metrics.
    var _a = detectDomainRealm(), realm = _a[0], domain = _a[1];
    var producer = KATAL_MONS_SUSHI_PRODUCER;
    var builder = new katal_metrics_driver_sushi_1.default.Builder()
        .withCustomProducer(producer)
        .withCustomSourceGroup(SOURCE_GROUPS[domain])
        .withDomainRealm(domain, realm);
    builder.withErrorHandler(errorHandler);
    return builder;
}
exports.createDriverConfigBuilder = createDriverConfigBuilder;
/**
 * Creates AWSMonitoringDriver for the passed config.
 * @param driverOptions Config options for AWS driver.
 * @param sushiDriver SushiDriver for migration use-cases.
 * @returns AWSMonitoringDriver with required configurations.
 */
function createAWSMonitoringDriver(driverOptions) {
    // If we couldn't autodetect domain or realm, we already logged an error above
    // Now just use defaults, because some metrics are better than no metrics.
    var _a = detectDomainRealm(), realm = _a[0], domain = _a[1];
    var domainFromEnum = katal_monitoring_aws_driver_1.KatalMetricDomain[domain.toUpperCase()];
    return new katal_monitoring_aws_driver_1.KatalMonitoringDriver(__assign({ realm: realm, domain: domainFromEnum }, driverOptions));
}
exports.createAWSMonitoringDriver = createAWSMonitoringDriver;
/**
 * Reads mons meta-tags on page
 */
function detectDomainRealm() {
    var metricsDatasetId = getMetaContent(DATASET_ID_META);
    if (!METRICS_DATASET_MAP[+metricsDatasetId]) {
        throw new Error("The dataset id '".concat(metricsDatasetId, "' in the '").concat(DATASET_ID_META, "' meta tag is not currently supported."));
    }
    return METRICS_DATASET_MAP[+metricsDatasetId].split('-');
}
exports.detectDomainRealm = detectDomainRealm;
/**
 * Capitalize the first letter of a string
 */
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Create an error handler that uses the CSM window.ueLogError if it is available, and otherwise logs to the console
 * You only need to call this if you want to supplement the default error handling.  Most applications will not need to do that.
 *
 * @return Error handler function
 */
function createErrorHandler() {
    return function (err) {
        if (!window.ueLogError) {
            console.error(err, ADDITIONAL_LOG_ERROR_INFO);
        }
        else {
            window.ueLogError(err, ADDITIONAL_LOG_ERROR_INFO);
        }
    };
}
exports.createErrorHandler = createErrorHandler;
//# sourceMappingURL=index.js.map